export enum OrderPaymentMethodEnum {
  CreditCard = 'carta_di_credito',
  Cash = 'contanti',
  RID = 'RID',
}
